import './style.css'
// import '../../assets/logo.jpg'


export const Footer = () => {

    return(
        <nav>
            <ul>
                <li className="menu">О нас</li>
                <li>Instagram</li>
                <li>Facebook</li>
                <li>VK</li>
            </ul>

        </nav>
    )
  
}


export default Footer;
